import { ReducerName } from 'reduxInfra/shared';
import time from './time';
import { teamPermissionsReducer } from 'PermissionsModule/reducers/teamPermissions';

export const reducerMap = {
  time,
  [ReducerName.TeamPermissions]: teamPermissionsReducer
};
